import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';


export default class CloseOutCost extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Cost
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Planned project cost({this.props.report.symbol}):</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.planned_cost}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Actual project cost({this.props.report.symbol}):</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.actual_cost}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Variance({this.props.report.symbol}):</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.variance}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Project was:</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.budget}
            </Typography>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CloseOutCost.js